import type { ReactNode } from "react";
import { Radio } from "@circle-react-uikit/Radio";
import { TemplateNameField } from "./TemplateNameField";

export interface TemplateFieldProps {
  checked: boolean;
  label: ReactNode;
  name: string;
  value: string;
}

export const CreateTemplateField = ({
  name,
  label,
  checked,
  value,
}: TemplateFieldProps) => (
  <Radio
    id={`${name}-radio-${value}`}
    label={label}
    checked={checked}
    innerBlock={<TemplateNameField checked={checked} />}
    labelClassName="m-0 text-base font-normal leading-5 normal-case text-dark"
    labelWrapperClassName="ml-4 w-full"
  />
);
